import { createContext } from 'react';
import * as signalR from '@microsoft/signalr';

export interface ISignalRContext {
  connection: signalR.HubConnection | null;
}

export const SignalRContext = createContext<ISignalRContext>({ connection: null });